export default "__VITE_ASSET__CfCef9Oe__"